<h1 class="accent-background-element">Map</h1>

<mat-dialog-content>
  <input #mapSearchField class="my-map-search-field" type="text">

  <google-map id="selection-map" width="100%" [options]="mapConfigurations">
    @if (markerPosition) {
      <map-marker [position]="markerPosition" [options]="markerOptions"></map-marker>
    }
  </google-map>

</mat-dialog-content>

<mat-dialog-actions>
  <div class="spacer"></div>
  <button mat-raised-button color="accent" (click)="onSubmit()">Select</button>
</mat-dialog-actions>